export function getItemByPercentage<T>(arr: T[], percentage: number): T | undefined {
  if (percentage < 0 || percentage > 100) {
    throw new Error('Percentage must be between 0 and 100');
  }

  if (arr.length === 0) {
    return undefined;
  }

  const index = Math.floor((percentage / 100) * (arr.length - 1));

  return arr[index];
}
